import { Component } from '@angular/core';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions, FormlyModule } from '@ngx-formly/core';
import { signal } from '@angular/core';
import { CommonModule, NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonDirective, ButtonLabel, ButtonModule } from 'primeng/button';
import { FileUpload, FileUploadModule } from 'primeng/fileupload';
import { InputGroup, InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddon, InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputText, InputTextModule } from 'primeng/inputtext';
import { Textarea, TextareaModule } from 'primeng/textarea';
import { FormlyTabsModule } from 'ngx-formly-tabs';

@Component({
    selector: 'app-formly',
    imports: [
        ReactiveFormsModule,
        FormlyModule
    ],
    templateUrl: './formly.component.html',
    styleUrl: './formly.component.scss',
})
export class FormlyComponent {

    form = new UntypedFormGroup({});
    model: any = {};
    options: FormlyFormOptions = {};
    fields: FormlyFieldConfig[] =  [
        {
            fieldGroupClassName: 'flex flex-col-2',
            fieldGroup: [
                {
                    className: 'flex-1',
                    type: 'input',
                    key: 'firstName',
                    props: {
                        label: 'First Name',
                    },
                },
                {
                    className: 'flex-1',
                    type: 'input',
                    key: 'lastName',
                    props: {
                        label: 'Last Name',
                    },
                    expressions: {
                        'props.disabled': '!model.firstName',
                    },
                },
            ],
        },
        {
            template: '<hr /><div><strong>Address:</strong></div>',
        },
        {
            fieldGroupClassName: 'display-flex',
            fieldGroup: [
                {
                    className: 'flex-2',
                    type: 'input',
                    key: 'street',
                    props: {
                        label: 'Street',
                    },
                },
                {
                    className: 'flex-1',
                    type: 'input',
                    key: 'cityName',
                    props: {
                        label: 'City',
                    },
                },
                {
                    className: 'flex-1',
                    type: 'input',
                    key: 'zip',
                    props: {
                        type: 'number',
                        label: 'Zip',
                        max: 99999,
                        min: 0,
                        pattern: '\\d{5}',
                    },
                },
            ],
        },
        {
            template: '<hr />',
        },
        {
            type: 'input',
            key: 'otherInput',
            props: {
                label: 'Other Input',
            },
        },
        {
            type: 'checkbox',
            key: 'otherToo',
            props: {
                label: 'Other Checkbox',
            },
        },
    ];
}
